import FactPicker from './FactPicker';

export default FactPicker;
